import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetLocationListOutput } from './GetLocationListOutput';

export class GetLocationListService extends HttpServiceBase {

  handle = (): Promise<Result<GetLocationListOutput> | null> => {
    const promise = this.http.get<Result<GetLocationListOutput>>(`${this.baseUrlSislogApi}/v2/location`);
    return promise;
  }
}